<template>
  <div @touchmove="preLoad(getPre)">
    <classify :category-list="indexCategoryList" :type="1"></classify>
    <default-page v-if="showDefaultPage"></default-page>
    <list v-else class="hasPadding" :list="courseList"></list>
    <p style="text-align:center;margin-top: 1rem" v-show="!courseList.length">
      <inline-loading></inline-loading>
      <span style="vertical-align:middle;display:inline-block;font-size:14px;">
        &nbsp;&nbsp;加载中
      </span>
    </p>
  </div>
</template>
<script>
import Classify from '@/components/Classify.vue';
import List from './components/list.vue';
import { mapState } from 'vuex';
import { course } from '@/api/ajax.js';
import { loadMore } from '@/Mixin/loadMore.js';
export default {
  name: '',
  mixins: [loadMore],
  data() {
    return {
      courseList: [],
      params: {
        pageNo: 1,
        pageSize: 20
      },
      loadFlag: true,
      indexCategoryList: []
    };
  },
  methods: {
    info() {
      //初始化滑动
      this.courseList = [];
      this.params.pageNo = 1;
      this.loadFlag = true;
    },
    getList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        course.courseList(data).then(res => {
          if (!this.courseList.length && !res.data.data.list.length) {
            this.showDefaultPage = true;
          } else {
            this.showDefaultPage = false;
          }
          for (var i = 0; i < res.data.data.list.length; i++) {
            this.courseList.push(res.data.data.list[i]);
          }
          if (res.data.data.list.length < 20) {
            this.loadFlag = false;
            return false;
          }
          this.params.pageNo += 1;
          this.loadFlag = true;
        });
      }
    },
    getPre() {
      this.getList(
        Object.assign(this.params, {
          firstId: this.classifyId.id
        })
      );
    },
    indexCategory() {
      course.indexCategory().then(res => {
        this.indexCategoryList = res.data.data;
      });
    }
  },
  computed: {
    ...mapState({
      classifyId: state => state.classifyId
    })
  },
  watch: {
    //classifyId 触发 改变内容
    classifyId(val) {
      this.info();
      this.getList(
        Object.assign(this.params, {
          firstId: val.id
        })
      );
    }
  },
  components: {
    List,
    Classify
  },
  created() {
    this.indexCategory();
    this.getPre();
    if (/isTemp=1/.test(location.href)) {
      sa.track(
        'activity',
        {
          sms_campaign: 'recorded_link_mb',
          web_edition: 2
        },
        function() {}
      );
    }
    if (/isTemp=2/.test(location.href)) {
      //首管消息
      sa.track(
        'first_attention',
        {
          from: 'wx',
          type: 'Course_playback',
          web_edition: 2
        },
        function() {}
      );
    }
  }
};
</script>
